import { render, staticRenderFns } from "./ProductFilter.vue?vue&type=template&id=08ac015f&scoped=true"
import script from "./ProductFilter.vue?vue&type=script&lang=js"
export * from "./ProductFilter.vue?vue&type=script&lang=js"
import style0 from "./ProductFilter.vue?vue&type=style&index=0&id=08ac015f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ac015f",
  null
  
)

export default component.exports